export default "__VITE_ASSET__B8SK_Jnl__"